export const OpenPDF = () => {
    const pdfUrl = './pdf/Harshad_Resume.pdf';
    window.open(pdfUrl, '_self');
};